import { useCallback, useRef } from 'react'

export const shuffle = (array: Array<any>, seed: number) => {
  let currentIndex = array.length,
    temporaryValue,
    randomIndex
  seed = seed || 1
  let random = function () {
    const x = Math.sin(seed++) * 10000
    return x - Math.floor(x)
  }
  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(random() * currentIndex)
    currentIndex -= 1
    // And swap it with the current element.
    temporaryValue = array[currentIndex]
    array[currentIndex] = array[randomIndex]
    array[randomIndex] = temporaryValue
  }
  return array
}

export const useSeededShuffle = () => {
  const seed = useRef(Math.floor(Math.random() * 1000)).current

  return useCallback((array: Array<any>) => shuffle(array, seed), [seed])
}
